import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

export const OfferAssetGeneralDetailsSummary = ({ generalData, t }) => (
  <Grid container alignItems='center' spacing={1}>
    <Grid item xs={12} lg={6} xl={4} display='flex' gap={1}>
      <strong>{t('OfferEdit.Asset.GeneralDetails.UserName')}:</strong>
      <Typography id={'offerAssetGeneralCard_summary_user'}>{generalData.userName}</Typography>
    </Grid>
    <Grid item xs={12} lg={6} xl={8} display='flex' gap={1}>
      <strong>{t('OfferEdit.Asset.GeneralDetails.Dealer')}:</strong>
      <Typography id={'offerAssetGeneralCard_summary_partner'}>{generalData.responsiblePartnerName}</Typography>
    </Grid>
  </Grid>
);

OfferAssetGeneralDetailsSummary.propTypes = {
  generalData: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(OfferAssetGeneralDetailsSummary);
